export default __webpack_public_path__ + "static/media/402.b4fdd2a6.png";